const resolveBoolean = (...values) => {
  for (const value of values) {
    if (typeof value === 'boolean') return value;
  }
  return null;
};

const hasAdminAccess = (source) =>
  source?.user?.isAdmin === true || source?.isAdmin === true;

export const getRestaurantSnapshot = (source = {}) => {
  const restaurant = source?.restaurant || source?.restaurante || {};
  const isActive = resolveBoolean(
    restaurant?.isActive,
    restaurant?.is_ativo,
    source?.is_ativo,
    source?.restaurante_ativo,
    source?.restaurant_active
  );

  return { isActive };
};

export const hasRestaurantAccess = (source) => {
  if (!source) return false;
  if (hasAdminAccess(source)) return true;

  const { isActive } = getRestaurantSnapshot(source);
  if (isActive === null) return true;
  return isActive;
};